import script from "./AppSettingsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSettingsTab.vue?vue&type=script&setup=true&lang=js"

import "./AppSettingsTab.vue?vue&type=style&index=0&id=83a1b952&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83a1b952"]])

export default __exports__